import { Course } from '../courses/types';

export interface ClassListItem {
  classId: MongoId;
  startTime: UnixTime;
  endTime: UnixTime;
  isIncharge: boolean;
  numActivities: {
    polls: number;
    quizzes: number;
    discussions: number;
    resources: number;
  };
}

export enum ClassStatus {
  /** Indicates that class was never started */
  NO_RECORD = 'noRecord',
  /** Indicates that class is yet to start */
  OPEN = 'open',
  /** @deprecated Not used anymore, here for legacy support only */
  HOLIDAY = 'holiday',
  /** Indicates that class has been cancelled */
  CANCELED = 'canceled',
  /** Indicates that class have been actually ended */
  CLOSED = 'closed',
  /** Indicates that class has started but not yet ended */
  IN_SESSION = 'inSession',
}

export interface AttendanceCourseData extends DistributiveOmit<Course, 'isPro' | 'canProxy' | 'courseType'> {}

export interface AttendanceClassData {
  classId: MongoId;
  title: string;
  endTime: UnixTime;
  startTime: UnixTime;
  isIncharge: boolean;
  numAttempts: number;
  numPresent: number;
}

export interface AttendanceDataItem {
  courseData: AttendanceCourseData;
  classData: AttendanceClassData[];
}

export interface AttendanceData {
  inSession: AttendanceDataItem[];
  nextScheduled: AttendanceDataItem[];
}

export enum AttendanceWarningAction {
  SHOW_WARNING = 'showWarning',
  HIDE_WARNING = 'hideWarning',
}

type AttendanceNotInProgressData = { inProgress: false };

type AttendanceInProgressData = {
  inProgress: true;
  startedAt: UnixTime;
};

type ClassAttendance = (AttendanceNotInProgressData | AttendanceInProgressData) & {
  numOfAttempts: number;
  markedInStudents: number;
};

export enum AttendanceProcessFailureType {
  ATTENDEE_FAILURE = 'attendee_failure',
  UNRESPONSIVE_ATTENDEES_FAILURE = 'unresponsive_attendees_failure',
}

export enum AttendanceFailureCode {
  NO_PERMISSIONS = 'noPermissions',
  BLE_NOT_SUPPORTED = 'bleNotSupported',
  NO_GPS = 'noGPS',
}

export interface AttendanceProcessAttendeeFailure {
  type: AttendanceProcessFailureType.ATTENDEE_FAILURE;
  failedOn: UnixTime;
  failureCode: AttendanceFailureCode;
  attendee: {
    userId: string;
    name: string;
    avatar: string;
    role: 'student';
  };
}

export interface AttendanceProcessUnresponsiveAttendeesFailure {
  type: AttendanceProcessFailureType.UNRESPONSIVE_ATTENDEES_FAILURE;
  failedOn: UnixTime;
  unresponsiveAttendees: number;
}

export type AttendanceProcessFailure =
  | AttendanceProcessAttendeeFailure
  | AttendanceProcessUnresponsiveAttendeesFailure;

export interface AttendanceInProgress {
  isInProgress: boolean;
  /** whether attendance type is proxy */
  isProxy: boolean;
  /**
   * @deprecated - not used in ppt addin
   * number of students who registered for this attendance,
   * `-1` means unknown
   */
  available: number;
  /**
   * total number of students marked present across all attendance instances,
   * `-1` means unknown
   */
  present: number;
  /** number of students enrolled in the course */
  enrolled: number;
  /** number of students marked present in this attempt for this attendance */
  nowMarkedPresent: number;
  startedAt: UnixTime;
  /** -1, when not synced */
  failures: AttendanceProcessFailure[];
  failuresLastSyncedAt: UnixTime;
}

export interface Class {
  id: MongoId;
  startTime: UnixTime;
  endTime: UnixTime;
  status: ClassStatus;
  attendance: ClassAttendance;
  attendanceInProgress: AttendanceInProgress | null;
}
